import { CurrencyPipe, DatePipe, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIModule } from '@ot/ifta/ui';
import { TimeFormatPipe, UtilsModule } from '@ot/ifta/utils';
import {
  CommonImportsModule,
  JurisdictionPipe,
  SharedPipesModule
} from '@ot/shared/utils';
import { DataGridModule } from '@ot/shared/data-grid';
import { PaginationModule } from '@ot/shared/pagination';

@NgModule({
  imports: [
    CommonImportsModule,
    UIModule,
    UtilsModule,
    DataGridModule,
    PaginationModule,
    SharedPipesModule
  ],
  declarations: [],
  exports: [
    CommonImportsModule,
    UIModule,
    UtilsModule,
    DataGridModule,
    PaginationModule,
    SharedPipesModule
  ],
  providers: [
    CurrencyPipe,
    TimeFormatPipe,
    DatePipe,
    JurisdictionPipe,
    TitleCasePipe
  ]
})
export class SharedModule {}
